// Persistence boundary for tour progress.
//
// Today progress lives in localStorage (handled by pinia-plugin-persistedstate on
// the store). This interface is the seam where a cross-device backend sync can be
// added later WITHOUT touching the engine or the store's public API: implement
// `TourProgressSync` against a real endpoint and swap the provider in `providers.ts`.

export interface TourProgressSnapshot {
  completedTourIds: string[]
  skippedTourIds: string[]
  dismissedTourIds: string[]
  stepIndexByTour: Record<string, number>
}

export interface TourProgressSync {
  /** Best-effort push of the latest snapshot. Never throws to callers. */
  push(snapshot: TourProgressSnapshot): void
  /** Optional pull of a remote snapshot (returns null when unavailable). */
  pull(): Promise<TourProgressSnapshot | null>
}

/**
 * Default provider: no remote sync. localStorage (via the store's `persist`) is the
 * source of truth. Swap this for a backend-backed implementation later.
 */
export const localTourProgressSync: TourProgressSync = {
  push() {
    /* no-op — localStorage persistence is handled by the store */
  },
  async pull() {
    return null
  },
}
